// extracted by mini-css-extract-plugin
export default {"header":"Header_header__vzM3c","title":"Header_title__qd-nD"};